var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoftwareTech(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EDF2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.235 15.09l7.167-3.91a1.25 1.25 0 011.197 0l7.166 3.91c.402.219.652.64.652 1.097v7.626c0 .457-.25.878-.652 1.097L20.6 28.82a1.25 1.25 0 01-1.197 0l-7.167-3.91a1.25 1.25 0 01-.651-1.097v-7.626c0-.457.25-.878.65-1.097z",
    stroke: "#5782F2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5l5 2.5m0 0l5-2.5M20 20v5",
    stroke: "#5782F2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFREYyRkUiLz4KPHBhdGggZD0iTTEyLjIzNDkgMTUuMDg5OUwxOS40MDE2IDExLjE4MDhDMTkuNzc0NyAxMC45NzczIDIwLjIyNTYgMTAuOTc3MyAyMC41OTg3IDExLjE4MDhMMjcuNzY1NCAxNS4wODk5QzI4LjE2NyAxNS4zMDg5IDI4LjQxNjggMTUuNzI5OCAyOC40MTY4IDE2LjE4NzNWMjMuODEyN0MyOC40MTY4IDI0LjI3MDIgMjguMTY3IDI0LjY5MTEgMjcuNzY1NCAyNC45MTAxTDIwLjU5ODcgMjguODE5MkMyMC4yMjU2IDI5LjAyMjcgMTkuNzc0NyAyOS4wMjI3IDE5LjQwMTYgMjguODE5MkwxMi4yMzQ5IDI0LjkxMDFDMTEuODMzNCAyNC42OTExIDExLjU4MzUgMjQuMjcwMiAxMS41ODM1IDIzLjgxMjdWMTYuMTg3M0MxMS41ODM1IDE1LjcyOTggMTEuODMzNCAxNS4zMDg5IDEyLjIzNDkgMTUuMDg5OVoiIHN0cm9rZT0iIzU3ODJGMiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTE1IDE3LjVMMjAgMjBNMjAgMjBMMjUgMTcuNU0yMCAyMFYyNSIgc3Ryb2tlPSIjNTc4MkYyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgSoftwareTech as ReactComponent };